import axios from "axios";

const preview = (store) => {
  store.on("@init", () => ({
    preview: { isOpen: false, url: null, isLoading: false },
  }));

  store.on("preview/show", ({ preview, canvas }) => {
    const canvasData = canvas.DPE.persistent.toBase64();
    store.dispatch("preview/loading", true);
    axios
      .post("/wp-json/dpe/v1/render/preview/debug", { canvasData })
      .then((resp) => {
        console.info("Preview ", resp.data);
        if (resp.data.image) {
          store.dispatch("preview/url", resp.data.image);
        }
      })
      .catch((err) => {
        console.error("Preview failed", err);
      })
      .finally((_) => {
        store.dispatch("preview/loading", false);
      });
    preview.isOpen = true;
    return { preview };
  });
  store.on("preview/hide", ({ preview }) => {
    preview.isOpen = false;
    preview.url = null;
    return { preview };
  });

  store.on("preview/url", ({ preview }, url) => {
    preview.url = url;
    return { preview };
  });

  store.on("preview/loading", ({ preview }, loading) => {
    preview.isLoading = loading;
    return { preview };
  });
};

export default preview;
